<!--
 - Author : wanghongling.
 - Date   : 2019/5/27.
 - File   : dashboardPage.仪表盘组件
 -->

<template>
  <div class="dashboardBg" :id="id" :style="{width: dashboardObj.width||'200px', height:dashboardObj.height||'200px'}"></div>
</template>

<script>

export default {
  name: 'dashboard',
  data () {
    return {
      myDashboard: null
    }
  },
  props: {
    id: {
      type: String,
      default: 'test'
    },
    dashboardObj: {
      width: '130px',
      height: '130px'
    }
  },
  watch: {
    dashboardObj: {
      handler () {
        this.$nextTick(() => {
          // window.removeEventListener('resize', this.resizeEvent)
          this.makeDashboard()
        })
      },
      deep: true
    }
  },
  destroyed () {
    this.$echarts.dispose(this.myDashboard)
    // window.removeEventListener('resize', this.resizeEvent)
    this.myDashboard = null
  },
  mounted () {
    this.init()
  },
  methods: {
    /**
     * 初始化echart
     * @author: whl
     * @createDate: 2019/8/9
     * @return {Object}
     */
    init () {
      const that = this
      const myDashboard = that.$echarts.init(document.getElementById(that.id))
      that.myDashboard = myDashboard
      that.makeDashboard()
    },
    /**
     * echart赋值
     * @author: whl
     * @createDate: 2019/8/9
     * @return {Object}
     */
    makeDashboard () {
      const option = {
        // 基于准备好的dom，初始化echarts实例
        series: [
          {
            name: '左右对称的pie',
            type: 'pie',
            zlevel: 2,
            silent: true,
            radius: ['95%', '100%'],
            startAngle: -130,
            label: {
              normal: {
                show: false
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: (function () {
              const dataArr = []
              for (var i = 0; i < 4; i++) {
                if (i % 2 === 0) {
                  dataArr.push({
                    name: (i + 1).toString(),
                    value: 25,
                    itemStyle: {
                      normal: {
                        color: 'rgba(31,132,243,1)',
                        borderWidth: 0,
                        borderColor: 'rgba(0,0,0,0)'
                      }
                    }
                  })
                } else {
                  dataArr.push({
                    name: (i + 1).toString(),
                    value: 20,
                    itemStyle: {
                      normal: {
                        color: 'rgba(0,0,0,0)',
                        borderWidth: 0,
                        borderColor: 'rgba(0,0,0,0)'
                      }
                    }
                  })
                }
              }
              return dataArr
            })()
          },
          {
            type: 'gauge',
            name: '外圈灰色线',
            center: ['50%', '50%'],
            radius: '100%',
            startAngle: 270,
            endAngle: -89.9999,
            z: 1,
            axisLine: { // 坐标轴线
              lineStyle: {
                color: [
                  [1, 'rgba(3,53,138, 1)']
                ], // 属性lineStyle控制线条样式
                width: 5
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            },
            splitLine: { // 分隔线
              show: false
            },
            detail: {
              show: false
            }
          },
          {
            type: 'gauge',
            name: '外圈灰色线',
            center: ['50%', '50%'],
            radius: '94%',
            startAngle: 270,
            endAngle: -89.9999,
            z: 1,
            axisLine: { // 坐标轴线
              lineStyle: {
                color: [
                  [1, 'rgba(8,58,131, 1)']
                ], // 属性lineStyle控制线条样式
                width: 3
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            },
            splitLine: { // 分隔线
              show: false
            },
            detail: {
              show: false
            }
          },
          {
            name: '刻度外面的圆形',
            type: 'gauge',
            center: ['50%', '50%'],
            radius: '90%', // 仪表盘半径
            startAngle: 0,
            endAngle: 360,
            splitNumber: 0, // 仪表盘刻度的分割段数。
            axisLine: {
              lineStyle: { // // 坐标轴线
                shadowColor: '#3382bb',
                shadowBlur: 30,
                color: [
                  [1, 'rgba(9,77,151, 0.7)']
                ], // 属性lineStyle控制线条样式
                width: 2
              }
            },
            axisLabel: { // 刻度标签。
              show: false // 是否显示标签。
            },
            splitLine: { // 分隔线样式。
              show: false // 是否显示分隔线。
            },
            detail: { // 仪表盘详情，用于显示数据。
              show: false
            }
          },
          {
            name: '刻度盘上方的模糊的pie',
            type: 'pie',
            radius: ['62%', '86%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            z: -1,
            label: {
              normal: {
                show: false,
                position: 'center'
              },
              emphasis: {
                show: false,
                textStyle: {
                  fontWeight: 'bold'
                }
              }
            },
            itemStyle: {
              color: {
                type: 'radial',
                x: 0.5,
                y: 0.5,
                r: 0.5,
                colorStops: [{
                  offset: 0.8, color: 'rgba(42,100,159,.2)' // 80% 处的颜色
                }, {
                  offset: 0.96, color: 'rgba(42,100,159,.9)'// 100% 处的颜色
                }, {
                  offset: 1, color: 'rgb(45,139,194)'// 100% 处的颜色
                }]
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [{
              value: 5000
            }]
          },
          {
            name: '刻度',
            type: 'gauge',
            radius: '64%',
            min: 0,
            max: 100,
            center: ['50%', '50%'],
            splitNumber: 12, // 刻度数量
            startAngle: 225,
            endAngle: -40,
            axisLine: {
              show: true,
              lineStyle: {
                width: 0,
                color: [
                  [0.25, '#c3423d'],
                  [0.50, '#bd26b4'],
                  [0.75, '#f7f281'],
                  [1, '#44cf52']
                ]
              }
            }, // 仪表盘轴线
            axisLabel: {
              show: true,
              color: 'auto',
              fontSize: 12,
              distance: -30,
              formatter: function (params) {
                // var value = params.toFixed(2)
                const value = Math.floor(params)

                if (value === 0) {
                  return '0'
                } else if (value === 8) {
                  return '差'
                } else if (value === 33) {
                  return '中'
                } else if (value === 66) {
                  return '良'
                } else if (value === 91) {
                  return '优'
                } else if (value === 100) {
                  return '100'
                } else {
                  return ''
                }
              }
            }, // 刻度标签。
            axisTick: {
              splitNumber: 4,
              show: true,
              lineStyle: {
                color: 'auto',
                width: 1
              },
              length: 8
            }, // 刻度样式
            splitLine: {
              show: true,
              length: 12,
              lineStyle: {
                color: 'auto',
                width: 2
              }
            }, // 分隔线样式
            itemStyle: {
              color: '#fa7102', // 指针颜色
              shadowColor: '#fa7102',
              shadowBlur: 20
            },
            pointer: {
              width: 6,
              length: '130%'
            },
            detail: {
              show: true,
              color: 'auto',
              offsetCenter: [0, '92%'],
              textStyle: {
                fontWeight: 'bold',
                fontSize: 18
              },
              formatter: [
                (this.dashboardObj.text || ''), // 优良中差的字样
                '{name|' + '安全指数' + '}'
              ].join('\n'),
              rich: {
                name: {
                  fontSize: 12,
                  lineHeight: 20,
                  color: '#a0c0e6'
                }
              }
            },
            data: [{
              value: this.dashboardObj.value || 0
            }],
            animationDuration: 3000,
            animationDurationUpdate: 3000,
            animationEasing: 'elasticOut',
            animationDelay: function (idx) {
              return idx * 280 + 100
            }
          },
          {
            name: '饼图',
            type: 'pie',
            radius: ['0%', '30%'],
            center: ['50%', '50%'],
            hoverAnimation: false,
            itemStyle: {
              color: {
                type: 'radial',
                x: 0.5,
                y: 0.5,
                r: 0.5,
                colorStops: [{
                  offset: 0.8, color: 'rgba(1,10,27,.8)' // 80% 处的颜色
                }, {
                  offset: 0.96, color: 'rgba(11,52,102)'// 100% 处的颜色
                }, {
                  offset: 1, color: 'rgba(11,52,102)'// 100% 处的颜色
                }]
              },
              shadowColor: 'rgba(11,52,102)',
              shadowBlur: 10
            },
            label: {
              normal: {
                show: true,
                position: 'center',
                formatter: function (params) {
                  const value = Math.floor(params.value)
                  return '{value|' + value + '}'
                },
                rich: {
                  value: {
                    fontFamily: 'Courier New',
                    fontSize: 20,
                    color: '#fff',
                    fontWeight: 'bold',
                    verticalAlign: 'bottom'
                  }
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            animation: false,
            data: [{ // 中心数值
              value: this.dashboardObj.value || 0
            }]
          }
        ]

      }
      this.myDashboard.setOption(option)
      // window.addEventListener('resize', this.resizeEvent)
    },
    /**
     * echart图表适应
     * @author: whl
     * @createDate: 2019/8/9
     * @return {Object}
     */
    resizeEvent () {
      this.myDashboard.resize() // 使图表适应
    }
  }
}
</script>

<style>
.dashboardBg{
  /*background: url("../../assets/images/index/dashboardBg.png") center;*/
  /*background-size: 100%;*/
}
</style>



// WEBPACK FOOTER //
// src/components/echarts/customDashboard.vue